export default __webpack_public_path__ + "static/media/Background_00236.9a386e6d.png";